import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/CommonComponents/BaselineVsActual/components/Tooltip.module.scss';

interface Props {
    baseLine: {
        versionName: string;
        versionDate: number;
        startDate: number;
        finishDate: number;
    };
}

export const PlannedTooltip = ({ baseLine }: Props) => {
    return (
        <div data-testid={'table-selection'}>
            <table className={'tooltipTable'}>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Version Name</th>
                        <th>version date</th>
                        <th>start date</th>
                        <th>finish date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className={classes.spacer} />
                    <tr data-testid={'table-baseline'} className={classes.baseline}>
                        <td>Baseline (planned)</td>
                        <td>
                            <div className={classes.ellipsis}>{baseLine.versionName}</div>
                        </td>
                        <td className={classes.noWrap}>
                            {moment(baseLine.versionDate).isValid()
                                ? moment(baseLine.versionDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                        <td className={classes.noWrap}>
                            {moment(baseLine.startDate).isValid()
                                ? moment(baseLine.startDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                        <td className={classes.noWrap}>
                            {moment(baseLine.finishDate).isValid()
                                ? moment(baseLine.finishDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
